import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';

type Variables = {
  eventName: string;
  eventId: string;
  actionSource: 'website' | 'app';
  eventSourceUrl?: string;
  fbp?: string;
  fbc?: string;
  customData?: Record<string, unknown>;
};

export type SendMetaEventResponse = {
  data: { ok: boolean };
};

export const useSendMetaEvent = createMutation<
  SendMetaEventResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: 'v2/meta/track',
      method: 'POST',
      data: {
        event_name: variables.eventName,
        event_id: variables.eventId,
        action_source: variables.actionSource,
        event_source_url: variables.eventSourceUrl,
        fbp: variables.fbp,
        fbc: variables.fbc,
        custom_data: variables.customData,
      },
    }).then((response) => response.data),
});
